import React from 'react'

import styles from './styles.module.css'

const Arrow = () => (
  <svg
    className={styles.trendIndicatorArrow}
    width="6"
    height="9"
    viewBox="0 0 6 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0C3.27614 0 3.5 0.223858 3.5 0.5V6.79289L5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645C6.04882 5.34171 6.04882 5.65829 5.85355 5.85355L3.35355 8.35355C3.15829 8.54882 2.84171 8.54882 2.64645 8.35355L0.146447 5.85355C-0.0488155 5.65829 -0.0488155 5.34171 0.146447 5.14645C0.341709 4.95118 0.658291 4.95118 0.853553 5.14645L2.5 6.79289V0.5C2.5 0.223858 2.72386 0 3 0Z"
    />
  </svg>
)

export default Arrow
